import { List, ListItem, ListItemButton, Skeleton } from "@mui/material";
import React from "react";
import { HEADER_TYPE } from "components/ai-editor/sections/Header";
import { useTheme } from "@emotion/react";

export default function SectionNavigator({ documentId, sections, loading, sectionRefs }) {

  const theme = useTheme();

  const renderListElements = () => {
    if (loading) {
      return (
        <>
          <Skeleton height="32px"/>
          <Skeleton height="32px"/>
          <Skeleton height="32px"/>
          <Skeleton height="32px"/>
        </>
      );
    }
    const headers = sections.filter((section) => section.type === HEADER_TYPE.key);
    return headers.map((section) => {
      return (
        <ListItem key={section.id}>
          <ListItemButton
            sx={{
              color: theme.palette.text.main,
              fontSize: section.headerType === "subsection" ? "12px" : "14px",
              fontWeight: section.headerType === "title" ? "bold" : "",
            }}
            onClick={() => {
              sectionRefs.current[section.id]?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }}
          >
            {section.text || "New Section"}
          </ListItemButton>
        </ListItem>
      )
    })
  };

  return <List dense sx={{overflowY: "auto"}} p={2}>{renderListElements()}</List>;
}
